import Vue from "vue";
import router from "@/router/index"

let axiosRequest = async (OBJECT) => {
    if (OBJECT.data) {
        Object.keys(OBJECT.data).forEach(item => {
            if (typeof (OBJECT.data[item]) == undefined || OBJECT.data[item] == null) {
                delete OBJECT.data[item];
            }
        })
    } else {
        OBJECT.data = {};
    }
    var method = (OBJECT.method ? OBJECT.method : "POST").toUpperCase();
    let result =
    await Vue.prototype.$axios({
        method: method,
        url: OBJECT.url,
        headers: method === "POST" ? {
            'Content-Type':"application/x-www-form-urlencoded"
        } : null,
        params: method === "GET" ? {
            ...OBJECT.data,
            userid: window.localStorage.getItem("userid"),
            token: window.localStorage.getItem("token")
        } : {},
        data: method === "POST" ? {
            ...OBJECT.data,
            userid: window.localStorage.getItem("userid"),
            token: window.localStorage.getItem("token")
        } : {},
        // data:{
        //     ...OBJECT.params,
        // },
        // params:{
        //     ...OBJECT.data,
        //     userid: window.localStorage.getItem("userid"),
        //     token: window.localStorage.getItem("token")
        // },
    });
    let ret = ["非页面创建者不能删除"];
    if(result.status===200){
        if(result.data && result.data.flag==="false"){
            if(ret.indexOf(result.data.info)==-1) {
                router.replace({path: '/pages/login/PcLogin'})
            }
        }
        result = [{},result];
        if(OBJECT.success) {
            OBJECT.success(result[1]);
        }
        return result;
    }else {
        return null;
    }
}
export default axiosRequest